import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from ".";

export const fetchAccounts = createAsyncThunk("accounts/fetch", async (_, { getState }) => {
  const state: RootState = getState() as RootState;

  if (state.accounts.data?.length) return Promise.reject();

  return axios.get(`/accounts`).then((res) => res.data);
});

// Then, handle actions in your reducers:
const accountsSlice = createSlice({
  name: "accounts",
  initialState: {
    loading: false,
    total: 0,
    data: [] as Account[],
  },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: {
    [fetchAccounts.fulfilled.type]: (state, action) => {
      const data = action.payload.records;
      state.data = data;
      state.total = action.payload.count;
      state.loading = false;
    },
    [fetchAccounts.pending.type]: (state, action) => {
      state.loading = true;
    },
    [fetchAccounts.rejected.type]: (state, action) => {
      state.loading = false;
    },
  },
});

//export const { fetchInvoices } = postsSlice.actions;
export default accountsSlice.reducer;

interface Account {
  attributes: {
    type: string;
    url: string;
  };
  AccountNumber?: string | null;
  Account_Status__c: string;
  Id: string;
  IsDeleted: boolean;
  Name: string;
  Vendor_Account_Type__c: string;
  Vendor_ID__c?: string | null;
  Vendor__c: boolean;
}
